export const languageOptions = [
    {
        value: 'ar',
        label: `Arabic (العربية)`
    },
    {
        value: 'zh-CN',
        label: `Chinese-Simplified (简体中文)`
    },
    {
        value: 'zh-TW',
        label: `Chinese-Traditional (繁體中文)`
    },
    {
        value: 'hr',
        label: `Croatian (Hrvatski)`
    },
    {
        value: 'nl',
        label: `Dutch (Nederlands)`
    },
    {
        value: 'en',
        label: `English`
    },
    {
        value: 'fi',
        label: `Finnish (Suomi)`
    },
    {
        value: 'fr',
        label: `French (Français)`
    },
    {
        value: 'de',
        label: `German (Deutsch)`
    },
    {
        value: 'el',
        label: `Greek (Ελληνικά)`
    },
    {
        value: 'hi',
        label: `Hindi (हिन्दी)`
    },
    {
        value: 'it',
        label: `Italian (Italiano)`
    },
    {
        value: 'ja',
        label: `Japanese (日本語)`
    },
    {
        value: 'ko',
        label: `Korean (한국어)`
    },
    {
        value: 'pl',
        label: `Polish (Polski)`
    },
    {
        value: 'pt',
        label: `Portuguese (Português)`
    },
    {
        value: 'ro',
        label: `Romanian (Română)`
    },
    {
        value: 'ru',
        label: `Russian (Русский)`
    },
    {
        value: 'es',
        label: `Spanish (Español)`
    },
    {
        value: 'sv',
        label: `Swedish (Svenska)`
    },
    {
        value: 'ur',
        label: `Urdu (اُردُو)`
    },
    {
        value: 'vi',
        label: `Vietnamese (Tiếng Việt)`
    }
];

//# sourceMappingURL=languageOptions.js.map